import { initializeApp, type FirebaseOptions } from 'firebase/app'
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider } from 'firebase/auth'

export default defineNuxtPlugin((nuxtApp) => {
    const firebaseConfig: FirebaseOptions = {
        apiKey: 'AIzaSyDlSJTIzVIldGAAs5dsqKBOwvsz4nI-q8M',
        authDomain: 'yourservice-app.firebaseapp.com',
        projectId: 'yourservice-app',
        storageBucket: 'yourservice-app.firebasestorage.app',
        messagingSenderId: '740832138205',
        appId: '1:740832138205:web:cc17a8e5c8d6ef20c05c34',
        measurementId: "G-ZS1N85J325"
    } satisfies FirebaseOptions
    
    const app = initializeApp(firebaseConfig)
    const auth = getAuth(app)

    const googleProvider = new GoogleAuthProvider()
    const facebookProvider = new FacebookAuthProvider()
    const appleProvider = new OAuthProvider('apple.com')

    nuxtApp.provide('auth', auth)
    nuxtApp.provide('googleProvider', googleProvider)
    nuxtApp.provide('facebookProvider', facebookProvider)
    nuxtApp.provide('appleProvider', appleProvider)
}) 